module.exports = __webpack_public_path__ + "static/media/membership card icon (active).beee2aaa.svg";